module.exports = __webpack_public_path__ + "static/media/oneSlidingInstallGuide.8fcde897.png";